import { format } from "date-fns";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormTextarea } from "src/core/components/custom-ui/form-textarea";
import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { useCloseMission } from "src/core/hooks/folder/useCloseMission";
import { IMission } from "src/core/hooks/folder/useFolderMissions";

type CloseMissionModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  mission: IMission | null;
  setMissionToEdit: (mission: IMission | null) => void;
};

export default function CloseMissionModal({
  open,
  setOpen,
  mission,
  setMissionToEdit,
}: CloseMissionModalProps) {
  const { t } = useTranslation();

  const { form, onSubmit, isLoading } = useCloseMission(mission, setOpen, setMissionToEdit);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="w-[440px]"
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="modal-add-stakeholder-header">
          <DialogTitle>{t("closeMission.modal.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("closeMission.modal.description")}
          </DialogDescription>
        </DialogHeader>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="font-medium uppercase mb-5">{t("form.closeMission.missionType")}</div>
            <div className="font-light mb-10">{mission?.missionType}</div>
            <div className="font-medium uppercase mb-5">{t("form.closeMission.missionDate")}</div>
            <div className="font-light mb-20">
              {mission?.renewDate ? format(mission.renewDate, "dd/MM/yyyy") : ""}
            </div>
            <FormTextarea
              name="statusComment"
              label={t("form.closeMission.statusComment")}
              control={form.control}
              required
            />

            <DialogFooter>
              <Button type="submit" variant="default" className="ml-[20px]" loading={isLoading}>
                {t("form.closeMission.submit")}
              </Button>
              <Button
                variant="link"
                onClick={(event) => {
                  event.preventDefault();
                  setOpen(false);
                  setMissionToEdit(null);
                }}
              >
                {t("global.form.cancel")}
              </Button>
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
